
import * as d3 from 'd3'
export default {
  methods: {

    draw_Blocks() {
      
      this.canvasBlock = this.svg
      .append('g')
      .attr('transform', `translate(${this.table.x+.5}, ${this.table.y+.5})`)
      .attr('font-family', 'roboto').attr('cursor', 'default')

      let blocks = this.canvasBlock
      .append('g')
      .attr('transform', `translate(0, 0)`)

      let box = {x: 0,y: 0,width: 120, height: 75, len: 7 }


      this.rawData.forEach((d,i)=> {

         blocks
        .append('rect')
        .attr('x', box.x).attr('y', box.y).attr('rx', 3)
        .attr('width', box.width).attr('height', box.height)
        .attr('fill', '#fff')
        .attr('stroke', d.A_SD ? '#83D2F5' : '#E0E0DF')
        .attr('stroke-width', d.A_SD ? 1 : .5)

        //  blocks
        // .append('image')
        // .attr('xlink:href', this.HOST + `/Monthly_Report/Erection/${d.ER_BK}.jpg`)
        // .attr('x', box.x+10).attr('y', box.y+6.5).attr('width', 100)
        // .attr('opacity', d.A_SD ? 1 : .4)

        blocks
        .append('text')
        .attr('x', box.x).attr('y', box.y-3)
        .attr('font-size', this.table.blk.tSize).attr('fill', this.table.blk.tColor)
        .text(d.ER_BK)

        // Delta Value
        if(d.A_SD) {
          let delta = this.gmx_dateDiff(d.P_SD, d.A_SD)

          blocks
          .append('text')
          .attr('x', box.x + box.width - 12).attr('y', box.y -3)
          .attr('font-size', this.table.delta.tSize).attr('text-anchor', 'end')
          .attr('fill', this.gmx_deltaValue(delta))
          .text(delta)

          blocks // Aarow
          .append('path')
          .attr('transform', `translate(${box.x + box.width - 10}, ${box.y -this.table.delta.y}) scale(${this.table.delta.scale})`)
          .attr('d', this.gmx_deltaValue(delta, 'icon'))
          .attr('fill', this.gmx_deltaValue(delta))
          .attr('stroke-width', .5)
          }

        blocks
        .append('text')
        .attr('x', box.x).attr('y', box.y + box.height + 11)
        .attr('font-size', this.table.plan.tSize).attr('fill', this.table.plan.tColor)
        .text(d.P_SD)

        blocks
        .append('text')
        .attr('x', box.x + box.width/2).attr('y', box.y + box.height + 11)
        .attr('font-size', 10).attr('fill', '#757575').attr('text-anchor', 'middle')
        .text('-')

        blocks
        .append('text')
        .attr('x', box.x + box.width).attr('y', box.y + box.height + 11)
        .attr('font-size', this.table.act.tSize).attr('fill', this.table.act.tColor).attr('text-anchor', 'end')
        .text(d.A_SD)

        
        



        box.x += (box.width + 10)
        if((i+1)/box.len == parseInt((i+1)/box.len)) {
          box.x = 0
          box.y += (box.height+60)
        }
      })



      // this.canvasBlock
      // .append('image')
      // .attr('xlink:href', this.HOST + '/Monthly_Report/Erection/Erection_WC212.jpg')
      // .attr('x', 20).attr('y', 5).attr('width', 400)




    },

  }
}